import React from 'react'
import { connect } from 'react-redux'
import styles from './MapViewer.scss'
import blockSizes from '../../../App/blockSizes.scss'
import { rrMessages } from 'features/ride_reports/intlMessages'
import { Map } from 'common/Map'
import { BlockLoading } from 'common/BlockLoading'
import { Metrics } from 'common/Metrics'
import { userIsAdmin } from 'lib/utils'
import { validatedHighlightSlice } from 'lib/reportUtils'
import { Msg } from 'lib/localization'
import cx from 'classnames'
import { FormattedMessage as T } from 'react-intl'

export const MapViewer = ({ block, ride, blockProps }) => {
  const data = block.getData()
  const rideId = data.get('rideId')
  const sampleGraph = data.get('sampleGraph', true)
  const showMetrics = data.get('showMetrics', false)
  // TODO figure out a good way to share these defaults between the viewer & editor
  const metricsToShow = data.get('metricsToShow', ['distance', 'eleGain', 'movingTime', 'avgSpeed', 'maxSpeed'])
  const overlay = data.get('overlay') || 'rwgps'
  // make sure the highlightSlice is valid before trying to render it
  const highlightSlice = validatedHighlightSlice(data, ride)
  const caption = data.get('caption')
  const { metricUnits } = blockProps

  const height = 420 + (sampleGraph && 150) + (showMetrics && 83)

  if (!ride) {
    return (
      <div className={blockSizes.normalBlock} >
        <BlockLoading height={height}><Msg m={rrMessages.loadingMap} /></BlockLoading>
        {caption && <figcaption className={styles.caption}>{caption}</figcaption>}
      </div>
    )
  }

  // todo clean up some of the markup here
  // todo passing [ride] means a new array is generated each render, which
  // in turn means that the Map is forced to re-render
  return (
    <div className={blockSizes.normalBlock} >
      <div className={cx(styles.MapViewer)}>
        <Map experimental={userIsAdmin} routes={[ride]}
          metricUnits={metricUnits}
          defaultOverlay={overlay}
          className={styles.Map}
          sampleGraph={sampleGraph}
          defaultHighlightSlice={highlightSlice}
          graphClassName={styles.sampleGraph} />
        {showMetrics && <Metrics ride={ride} metricUnits={metricUnits} highlightSlice={highlightSlice} metricsToShow={metricsToShow} />}
      </div>
      <div className={styles.leadLink}>
        <a href={`/trips/${rideId}`} target='_blank'><T id='MapViewer.viewFull' defaultMessage='view full ride' /> &raquo;</a>
      </div>
      {caption && <figcaption className={styles.caption}>{caption}</figcaption>}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  ride: state.trips.get(ownProps.block.getData().get('rideId'))
})

export const MapViewerContainer = connect(
  mapStateToProps,
  null
)(MapViewer)
